module.exports = __webpack_public_path__ + "img/payrun.119fbfad.svg";